/*
 * *
 *   ~  * Copyright (c) by INFODATA-GROUP. All rights reserved.
 *   ~  * No part of this publication may be reproduced, distributed,
 *   ~  * or transmitted in any form or by any means, including photocopying, recording,
 *   ~  * or other electronic or mechanical methods, without the prior written permission of the publisher,
 *   ~  * except in the case of brief quotations embodied in critical
 *   ~  * reviews and certain other noncommercial uses permitted by copyright law.
 *   ~  * AUTHOR : bs
 *   ~  * DATE : 16/05/2025 14:30
 *
 */

import { Route } from '@angular/router';

import {
  PageLoginComponent,
  PageMaintenanceComponent,
  PagePwdResetComponent,
  PageResetRequestComponent,
} from '@infodata-group/inf-commons-desktop';

import { MenuGuard } from './guard/menu.guard';

import { authorizationGuardFn } from '@infodata-group/inf-commons';

export const appRoutes: Route[] = [
  { path: 'login', component: PageLoginComponent },
  {
    path: 'labo',
    loadComponent: () =>
      import('./page/page-labo/page-labo.component').then(
        (m) => m.PageLaboComponent,
      ),
  },
  { path: 'reset-request', component: PageResetRequestComponent },
  { path: 'new-password', component: PagePwdResetComponent },
  {
    path: 'not-found/:type',
    loadComponent: () =>
      import('./page/page-not-found/page-not-found.component').then(
        (m) => m.PageNotFoundComponent,
      ),
  },
  { path: 'maintenance', component: PageMaintenanceComponent },
  {
    path: '',
    loadComponent: () =>
      import('./page/page-container/page-container.component').then(
        (m) => m.PageContainerComponent,
      ),
    canActivate: [authorizationGuardFn],
    children: [
      {
        path: '',
        canActivate: [MenuGuard],
        children: [
          { path: '', redirectTo: 'redirect', pathMatch: 'full' },
          {
            path: 'redirect',
            loadComponent: () =>
              import('./page/page-redirect/page-redirect.component').then(
                (m) => m.PageRedirectComponent,
              ),
          },
          {
            path: 'dashboard',
            loadComponent: () =>
              import('./page/page-dashboard/page-dashboard.component').then(
                (m) => m.PageDashboardComponent,
              ),
          },
          {
            path: 'logbook',
            loadComponent: () =>
              import('./page/page-logbook/page-logbook.component').then(
                (m) => m.PageLogbookComponent,
              ),
          },
          {
            path: 'profil-pti',
            loadComponent: () =>
              import('./page/page-profil-pti/page-profil-pti.component').then(
                (m) => m.PageProfilPtiComponent,
              ),
          },
          {
            path: 'alarms',
            loadComponent: () =>
              import('./page/page-alarms/page-alarms.component').then(
                (m) => m.PageAlarmsComponent,
              ),
          },
          {
            path: 'alarms/:id/:unix',
            loadComponent: () =>
              import('./page/page-alarms/page-alarms.component').then(
                (m) => m.PageAlarmsComponent,
              ),
          },
          {
            path: 'daily-report-act',
            loadComponent: () =>
              import(
                './page/page-daily-report-activity/page-daily-report-activity.component'
              ).then((m) => m.PageDailyReportActivityComponent),
          },
          {
            path: 'report-onss',
            loadComponent: () =>
              import('./page/page-report-onss/page-report-onss.component').then(
                (m) => m.PageReportOnssComponent,
              ),
          },
          {
            path: 'ent-params',
            loadComponent: () =>
              import('./page/page-params-ent/page-params-ent.component').then(
                (m) => m.PageParamsEntComponent,
              ),
          },
          {
            path: 'chapier',
            children: [
              {
                path: 'tour',
                loadComponent: () =>
                  import(
                    './modules/chapier/page/chapier-page-tournee/chapier-page-tournee.component'
                  ).then((m) => m.ChapierPageTourneeComponent),
              },
              {
                path: 'dashboard',
                loadComponent: () =>
                  import(
                    './modules/chapier/page/chapier-page-dashboard/chapier-page-dashboard.component'
                  ).then((m) => m.ChapierPageDashboardComponent),
              },
              { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
              { path: '*', redirectTo: 'dashboard', pathMatch: 'full' },
            ],
          },
          {
            path: 'naturhome',
            children: [
              {
                path: 'daily-report-act-admin',
                loadComponent: () =>
                  import(
                    './modules/naturhome/page/naturhome-page-daily-report-activity-admin/naturhome-page-daily-report-activity-admin.component'
                  ).then(
                    (m) => m.NaturhomePageDailyReportActivityAdminComponent,
                  ),
              },
              {
                path: 'logbook',
                loadComponent: () =>
                  import(
                    './modules/naturhome/page/naturhome-page-logbook/naturhome-page-logbook.component'
                  ).then((m) => m.NaturhomePageLogbookComponent),
              },
            ],
          },
          {
            path: 'infodata-admin-menu',
            loadComponent: () =>
              import('./page/page-admin-menu/page-admin-menu.component').then(
                (m) => m.PageAdminMenuComponent,
              ),
          },
          {
            path: 'error/:type',
            loadComponent: () =>
              import('./page/page-not-found/page-not-found.component').then(
                (m) => m.PageNotFoundComponent,
              ),
          },
          {
            path: '**',
            loadComponent: () =>
              import('./page/page-standard/page-standard.component').then(
                (m) => m.PageStandardComponent,
              ),
          },
        ],
      },
    ],
  },
];
